import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../lang/LangContext';
import { LANGUAGES } from '../lang/index';

const LanguagePicker = () => {
    const { lang, setLang } = useLanguage();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [open]);

    const current = LANGUAGES[lang];

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen((o) => !o)}
                className="flex items-center gap-1.5 text-xs text-text-muted hover:text-accent transition-colors px-2 py-1 rounded-md hover:bg-surface-hover"
            >
                <span>{current.flag}</span>
                <span className="font-mono uppercase">{lang}</span>
            </button>

            {open && (
                <div className="absolute right-0 top-full mt-1 z-50 min-w-[120px] rounded-md border border-surface-border bg-surface-raised shadow-lg overflow-hidden">
                    {Object.entries(LANGUAGES).map(([code, { flag, label }]) => (
                        <button
                            key={code}
                            onClick={() => { setLang(code); setOpen(false); }}
                            className={`w-full flex items-center gap-2 px-3 py-2 text-xs text-left transition-colors hover:bg-surface-hover ${code === lang ? 'text-accent font-medium' : 'text-text-secondary'}`}
                        >
                            <span>{flag}</span>
                            <span>{label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguagePicker;
